export default __webpack_public_path__ + "static/media/ic_menu_overtime.b025fb5f.svg";